
// import React, { useRef } from "react";
// import { useLocation, Link, useNavigate } from "react-router-dom";
// import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
// import "../assets/css/styles.css";
// import sjs from "../assets/images/sjs-technologies.png";

// const Navbar = () => {
//   const navbarRef = useRef();
//   const location = useLocation();
//   const navigate = useNavigate();



//   const navbarHandler = () => {
//     navbarRef.current.classList.toggle("active");  
//   };

//   // const scrollToSection = (section) => {
//   //   if (location.pathname !== "/") {
//   //     navigate(`/#${section}`);
//   //   } else {
//   //     const element = document.getElementById(section);
//   //     if (element) {
//   //       scroll.scrollTo(element.offsetTop);
//   //     }
//   //   }
//   //   navbarHandler(); // Close the navbar after clicking a link
//   // };
//   const scrollToSection = (section) => {
//   if (location.pathname !== "/") {
//     // Navigate to the home page and then scroll without adding hash to the URL
//     navigate("/", { replace: true });
//     setTimeout(() => {
//       const element = document.getElementById(section);
//       if (element) {
//         scroll.scrollTo(element.offsetTop);
//       }
//     }, 100); // Adjust the timeout as needed
//   } else {
//     const element = document.getElementById(section);
//     if (element) {
//       scroll.scrollTo(element.offsetTop);
//     }
//   }
//   navbarHandler(); // Close the navbar after clicking a link
// };

//   const handleLinkClick = () => {
//     setTimeout(() => {
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }, 100); // Adjust the delay as needed
//     navbarHandler(); // Close the navbar after clicking a link
//   };

//   return (
//     <>
//       <header className="header">
//         <div className="logo-container">
//           <ScrollLink
//             to="/"
//             smooth={false}
//             duration={500}
//             onClick={() => scrollToSection("home")}
//           >
//             <img src={sjs} alt="Logo" width="70" height="70" />
//           </ScrollLink>
          
//         </div>
//         <nav className="navbar" ref={navbarRef}>
//           <ScrollLink
//             to="home"
//             smooth={false}
//             duration={500}
//             onClick={() => scrollToSection("home")}
//           >
//             Home
//           </ScrollLink>
//           <Link to="/aboutus" onClick={handleLinkClick}>About Us</Link>
//           <ScrollLink
//             to="courses"
//             smooth={false}
//             duration={500}
//             onClick={() => scrollToSection("courses")}
//           >
//             Courses
//           </ScrollLink>
//           <ScrollLink
//             to="contact"
//             smooth={false}
//             duration={500}
//             onClick={() => scrollToSection("contact")}
//           >
//             Contact Us
//           </ScrollLink>
//         </nav>
//         <div className="icons">
//           <div className="fas fa-bars" id="menu-btn" onClick={navbarHandler}></div>
//         </div>
//       </header>
//     </>
//   );
// }; 

// export default Navbar;
// import React, { useRef, useState } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
// import "../assets/css/styles.css";
// import sjs from "../assets/images/sjs-technologies.png";
// import courses from "../components/coursesData"; // Import course data

// const Navbar = () => {
//   const navbarRef = useRef();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   const navbarHandler = () => {
//     navbarRef.current.classList.toggle("active");
//   };

//   const toggleDropdown = () => {
//     setDropdownOpen(!dropdownOpen);
//   };

//   const handleCourseSelect = (course) => {
//     navigate(`/course/${course.className}`);
//     setDropdownOpen(false);
//     navbarHandler();
//   };

//   const handleLinkClick = () => {
//     setTimeout(() => {
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }, 100); // Adjust the delay as needed
//     navbarHandler(); // Close the navbar after clicking a link
//   };

//   const scrollToSection = (section) => {
//     if (location.pathname !== "/") {
//       navigate("/");
//       setTimeout(() => {
//         scroll.scrollTo(document.getElementById(section).offsetTop - 50, {
//           smooth: true,
//         });
//       }, 200);
//     } else {
//       scroll.scrollTo(document.getElementById(section).offsetTop - 50, {
//         smooth: true,
//       });
//     }
//     navbarHandler();
//   };

//   return (
//     <header className="header">
//       <div className="logo-container">
//         <ScrollLink to="home" smooth={true} duration={500} onClick={() => scrollToSection("home")}>
//           <img src={sjs} alt="Logo" width="70" height="70" />
//         </ScrollLink>
//       </div>

//       <nav className="navbar" ref={navbarRef}>
//         <ScrollLink to="home" smooth={true} duration={500} onClick={() => scrollToSection("home")}>
//           Home
//         </ScrollLink>
//         <Link to="/aboutus" onClick={handleLinkClick}>About Us</Link>

//         {/* Dropdown for Courses */}
//         <div className="dropdown">
//           <button className="dropbtn" onClick={toggleDropdown}>
//             Courses ▾
//           </button>
//           {dropdownOpen && (
//             <div className="dropdown-content">
//               {Object.values(courses).map((course, index) => (
//                 <div key={index} onClick={() => handleCourseSelect(course)}>
//                   {course.name}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         <ScrollLink to="contact" smooth={true} duration={500} onClick={() => scrollToSection("contact")}>
//           Contact Us
//         </ScrollLink>
//       </nav>

//       <div className="icons">
//         <div className="fas fa-bars" id="menu-btn" onClick={navbarHandler}></div>
//       </div>
//     </header>
//   );
// };

// export default Navbar;


// import React, { useRef, useState } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
// import "../assets/css/styles.css";
// import sjs from "../assets/images/sjs-technologies.png";
// import courses from "../components/coursesData"; // Import course data

// const Navbar = () => {
//   const navbarRef = useRef();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [dropdownOpen, setDropdownOpen] = useState(false);

//   const navbarHandler = () => {
//     navbarRef.current.classList.toggle("active");
//   };

//   const toggleDropdown = () => {
//     setDropdownOpen(!dropdownOpen);
//   };

//   const handleCourseSelect = (course) => {
//     navigate(`/course/${course.className}`);
//     setDropdownOpen(false);
//     navbarHandler();
//   };

//   const handleLinkClick = () => {
//     setTimeout(() => {
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }, 100); // Adjust the delay as needed
//     navbarHandler(); // Close the navbar after clicking a link
//   };

//   const scrollToSection = (section) => {
//     if (location.pathname !== "/") {
//       navigate("/");
//       setTimeout(() => {
//         scroll.scrollTo(document.getElementById(section).offsetTop - 50, {
//           smooth: true,
//         });
//       }, 200);
//     } else {
//       scroll.scrollTo(document.getElementById(section).offsetTop - 50, {
//         smooth: true,
//       });
//     }
//     navbarHandler();
//   };

//   return (
//     <header className="header">
//       <div className="logo-container">
//         <ScrollLink to="home" smooth={true} duration={500} onClick={() => scrollToSection("home")}>
//           <img src={sjs} alt="Logo" width="70" height="70" />
//         </ScrollLink>
//       </div>

//       <nav className="navbar" ref={navbarRef}>
//         <ScrollLink to="home" smooth={true} duration={500} onClick={() => scrollToSection("home")}>
//           Home
//         </ScrollLink>
//         <Link to="/aboutus" onClick={handleLinkClick}>About Us</Link>

//         {/* Dropdown for Courses */}
//         <div className="dropdown">
//           <button className="dropbtn" onClick={toggleDropdown}>
//             Courses ▾
//           </button>
//           {dropdownOpen && (
//             <div className="dropdown-content">
//               {Object.values(courses).map((course, index) => (
//                 <div key={index} onClick={() => handleCourseSelect(course)}>
//                   {course.name}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         <ScrollLink to="contact" smooth={true} duration={500} onClick={() => scrollToSection("contact")}>
//           Contact Us
//         </ScrollLink>
//       </nav>

//       <div className="icons">
//         <div className="fas fa-bars" id="menu-btn" onClick={navbarHandler}></div>
//       </div>
//     </header>
//   );
// };

// export default Navbar 
import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import "../assets/css/styles.css";
import sjs from "../assets/images/sjs-technologies.png";
import courses from "../components/coursesData";

const Navbar = () => {
  const navbarRef = useRef();
  const dropdownRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const navbarHandler = () => {
    navbarRef.current.classList.toggle("active");
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  // const handleCourseSelect = (course) => {
  //   navigate(`/course/${course.className}`);
  //   setDropdownOpen(false);
  //   navbarHandler();
  // };
const handleCourseSelect = (course) => {
  navigate(`/course/${course.className}`);
  setDropdownOpen(false);
  navbarHandler();

  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, 200); // Delay ensures scroll happens after route loads
};

  const handleLinkClick = () => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
    navbarHandler();
  };

  const scrollToSection = (section) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        scroll.scrollTo(document.getElementById(section).offsetTop - 50, {
          smooth: true,
        });
      }, 200);
    } else {
      scroll.scrollTo(document.getElementById(section).offsetTop - 50, {
        smooth: true,
      });
    }
    navbarHandler();
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      <div className="logo-container">
        <ScrollLink to="home" smooth={true} duration={500} onClick={() => scrollToSection("home")}>
          <img src={sjs} alt="Logo" width="70" height="70" />
        </ScrollLink>
      </div>

      <nav className="navbar" ref={navbarRef}>
        <ScrollLink to="home" smooth={true} duration={500} onClick={() => scrollToSection("home")}>
          Home
        </ScrollLink>
        <Link to="/aboutus" onClick={handleLinkClick}>About Us</Link>

        {/* Scrollable Dropdown for Courses */}
        <div className="dropdown" ref={dropdownRef}>
  <button className="dropbtn" onClick={toggleDropdown}>
    Courses ▾
  </button>
  {dropdownOpen && (
    <div className="dropdown-content">
      {Object.values(courses).map((course, index) => (
        <div key={index} onClick={() => handleCourseSelect(course)}>
          {course.name}
        </div>
      ))}
    </div>
  )}
</div>


        <ScrollLink to="contact" smooth={true} duration={500} onClick={() => scrollToSection("contact")}>
          Contact Us
        </ScrollLink>
      </nav>

      <div className="icons">
        <div className="fas fa-bars" id="menu-btn" onClick={navbarHandler}></div>
      </div>
    </header>
  );
};

export default Navbar;